<details-section title="Simulation Information" [showDetails]="false">
  <div class="container" [formGroup]="form">
    <div class="inner-left">
      <qai-field
        [label]="'Name *'"
        [error]="
          isSimulationNameAlreadyExists
            ? 'A Simulation with the same name already exists.'
            : ''
        "
      >
        <input qai-input type="text" formControlName="simulationName" />
      </qai-field>

      <qai-field [label]="'Product'">
        <qai-floating-select
          [options]="moduleOptions"
          [placeholder]="'Select Product'"
          [placement]="'below-start'"
          [offset]="4"
          [shape]="'rectangle'"
          [value]="form.get('moduleUuid')?.value"
          [searchable]="true"
          [showActionButton]="true"
          actionButtonLabel="Add new product"
          (action)="onAddNewProduct($event)"
          (selectionChange)="form.get('moduleUuid')?.setValue($event?.value)"
          [disabled]="readOnly"
        ></qai-floating-select>
      </qai-field>

      <qai-field [label]="'Language'">
        <qai-floating-select
          [options]="languageOptions"
          [placement]="'below-start'"
          [offset]="4"
          [shape]="'rectangle'"
          [value]="form.get('language')?.value"
          (selectionChange)="form.get('language')?.setValue($event?.value)"
          [disabled]="readOnly"
        ></qai-floating-select>
      </qai-field>
    </div>

    <qai-field [label]="'Description'">
      <textarea
        qai-textarea
        qaiPasteClean
        autosize
        [maxLines]="30"
        formControlName="simulationDescription"
      ></textarea>
    </qai-field>
  </div>
</details-section>
